import { createFileRoute, redirect } from '@tanstack/react-router';

// /admin lands on the first sidebar item (Members). Only admins reach this
// route — the `_authed/admin` layout already redirects moderators to their
// moderation queue before this runs. The hub card-grid is gone; admin mirrors
// group-scoped admin (/circles/[id]/admin etc.), landing on its first section.
export const Route = createFileRoute('/_authed/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/members' });
  },
});
